import { type ReactElement } from 'react';

import classNames from 'classnames';

import {
  CHART_SHAPES,
  type ChartShape,
  ChartShapeGeometry,
} from '../ChartGraphic/ChartShapeGeometry';

import styles from './ResponsiveChartGraphic.module.css';

const RESPONSIVE_SHAPE_IDS: ChartShape['id'][] = ['bowtie', 'flower'];

const RESPONSIVE_CHART_SHAPES = CHART_SHAPES.filter(shape =>
  RESPONSIVE_SHAPE_IDS.includes(shape.id),
);

export const ResponsiveChartGraphic = (): ReactElement => (
  <div className={styles.responsiveDecor} aria-hidden="true">
    {RESPONSIVE_CHART_SHAPES.map(shape => (
      <span
        key={shape.id}
        className={classNames(styles.decor, styles[shape.id])}
      >
        <svg viewBox={shape.viewBox}>
          <ChartShapeGeometry shape={shape} />
        </svg>
        <i />
      </span>
    ))}
  </div>
);
